import React, { useEffect } from "react";
import type { Endereco } from "types/upsTypes";
import "../../../styles/ship.css";

function isMexico(pais?: string) {
    const p = String(pais || "").trim().toUpperCase();
    return p === "MX" || p === "MEX" || p === "MEXICO" || p === "MÉXICO";
}

type Props = {
    shipper: Endereco;
    setShipper: React.Dispatch<React.SetStateAction<Endereco>>;
    destinatario: Endereco;
    setDestinatario: React.Dispatch<React.SetStateAction<Endereco>>;

    paymentBill: "Shipper" | "Receiver" | "ThirdParty";
    setPaymentBill: (v: "Shipper" | "Receiver" | "ThirdParty") => void;

    triangulacao: "DDP" | "DDU" | "DAP";
    setTriangulacao: (v: "DDP" | "DDU" | "DAP") => void;

    loading: boolean;

    onNext: () => void; // 👉 novo: avança para CompareStep
    onBack: () => void;
};

export default function ShipStep(props: Props) {
    const {
        shipper,
        setShipper,
        destinatario,
        setDestinatario,
        paymentBill,
        setPaymentBill,
        triangulacao,
        setTriangulacao,
        loading,
        onNext,
        onBack,
    } = props;

    useEffect(() => {
        setDestinatario(prev => ({
            ...prev,
            telefone: prev.telefone || "17865994231"
        }));
    }, [destinatario.nome]);

    return (
        <div id="page-ups">
            <div id="card-ups">
                <form
                    onSubmit={(e) => {
                        e.preventDefault();
                        onNext();
                    }}
                    autoComplete="off"
                >
                    <h2>2 - Dados de Envio</h2>

                    <div className="grid-2">
                        <fieldset>
                            <legend>Remetente</legend>
                            <label>Nome/Razão</label>
                            <input value={shipper.nome} onChange={(e) => setShipper({ ...shipper, nome: e.target.value })} />
                            <label>Telefone</label>
                            <input value={shipper.telefone} onChange={(e) => setShipper({ ...shipper, telefone: e.target.value })} />
                            <label>Rua</label>
                            <input value={shipper.rua} onChange={(e) => setShipper({ ...shipper, rua: e.target.value })} />
                            <label>Número</label>
                            <input value={shipper.numero} onChange={(e) => setShipper({ ...shipper, numero: e.target.value })} />
                            <label>Complemento</label>
                            <input value={shipper.complemento} onChange={(e) => setShipper({...shipper, complemento: e.target.value})}/>
                            <label>Cidade</label>
                            <input value={shipper.cidade} onChange={(e) => setShipper({ ...shipper, cidade: e.target.value })} />
                            <label>Estado</label>
                            <input value={shipper.estado} onChange={(e) => setShipper({ ...shipper, estado: e.target.value })} />
                            <label>CEP</label>
                            <input value={shipper.cep} onChange={(e) => setShipper({ ...shipper, cep: e.target.value })} />
                            <label>País</label>
                            <input value={shipper.pais} onChange={(e) => setShipper({ ...shipper, pais: e.target.value })} />
                        </fieldset>

                        <fieldset>
                            <legend>Destinatário</legend>
                            <label>Nome</label>
                            <input value={destinatario.nome} onChange={(e) => setDestinatario({ ...destinatario, nome: e.target.value })} />
                            <label>Telefone</label>
                            <input value={destinatario.telefone || "17865994231"} onChange={(e) =>
                                setDestinatario({ ...destinatario, telefone: e.target.value })
                            } />
                            <label>Rua</label>
                            <input value={destinatario.rua} onChange={(e) => setDestinatario({ ...destinatario, rua: e.target.value })} />
                            <label>Número</label>
                            <input value={destinatario.numero} onChange={(e) => setDestinatario({ ...destinatario, numero: e.target.value })} />
                            <label>Cidade</label>
                            <input value={destinatario.cidade} onChange={(e) => setDestinatario({ ...destinatario, cidade: e.target.value })} />
                            <label>Estado</label>
                            <input value={destinatario.estado} onChange={(e) => setDestinatario({ ...destinatario, estado: e.target.value })} />
                            <label>CEP</label>
                            <input value={destinatario.cep} onChange={(e) => setDestinatario({ ...destinatario, cep: e.target.value })} />
                            <label>País</label>
                            <input value={destinatario.pais} onChange={(e) => setDestinatario({ ...destinatario, pais: e.target.value })} />
                            {isMexico(destinatario.pais) && (
                                <>
                                    <label>RFC (obrigatório p/ desembaraço no México)</label>
                                    <input
                                        value={destinatario.cnpjOuTaxId || ""}
                                        onChange={(e) => setDestinatario({ ...destinatario, cnpjOuTaxId: e.target.value })}
                                        placeholder="Ex: XAXX010101000"
                                    />
                                </>
                            )}
                        </fieldset>
                    </div>

                    <div style={{ marginTop: 12 }}>
                        <label>Pagamento</label>
                        <select value={paymentBill} onChange={(e) => setPaymentBill(e.target.value as any)}>
                            <option value="Shipper">Bill Shipper</option>
                            <option value="Receiver">Bill Receiver</option>
                            <option value="ThirdParty">Third Party</option>
                        </select>
                    </div>

                    <div style={{ marginTop: 12 }}>
                        <label>Triangulação</label>
                        <select value={triangulacao} onChange={(e) => setTriangulacao(e.target.value as any)}>
                            <option value="DDP">DDP</option>
                            <option value="DDU">DDU</option>
                            <option value="DAP">DAP</option>
                        </select>
                    </div>

                    <div className="acoes" style={{ marginTop: 16 }}>
                        <button type="button" className="botao botao--fantasma" onClick={onBack}>
                            Voltar
                        </button>
                        <button type="submit" className="botao botao--primario">
                            {loading ? "Carregando..." : "Próximo: Comparar"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

//botao de excluir caixa
